import { Outlet, useLocation, useNavigate } from "react-router-dom";
import { Breadcrumb } from "../../components/Breadcrumb";
import { requireAuth } from "../auth/RequireAuth";
import { TimeclockReport, timeclockReportLoader } from "./TimeclockReport";

const TimeclockReportIndex = () => {
  const location = useLocation();
  const navigate = useNavigate();

  if (location.pathname === "/timeclock-report") {
    navigate("/timeclock-report/view");
  }

  return <Outlet />;
};

export const timeclockReportRouter = {
  path: "/timeclock-report",
  id: "timeclock-report",
  element: <TimeclockReportIndex />,
  handle: {
    crumb: () => (
      <Breadcrumb name="Timeclock Report" href="/timeclock-report/view" />
    ),
  },
  loader: requireAuth(),
  children: [
    {
      path: "view",
      id: "timeclock-report-view",
      element: <TimeclockReport />,
      loader: timeclockReportLoader,
    },
  ],
};
